export default __webpack_public_path__ + "static/media/icon_more.7535aad1.svg";